import { useState } from "react"

function usePopoverToggles(initialState) {
    const [state, setState] = useState(initialState)
    const openPopover = (e, key) => {
        setState({ ...initialState, [key]: e.currentTarget })
    }
    const closePopover = key => {
        setState(initialState)
    }
    return [state, openPopover, closePopover]
}

export default usePopoverToggles